<div class="page-content permissions-page">
  <header class="permissions-header">
    <div class="permissions-title">
      <span class="page-eyebrow"><i class="ri-shield-keyhole-line"></i> Administração de acessos</span>
      <h1>Perfis e Permissões</h1>
      <p>Organize os perfis de acesso e controle o que cada equipa pode consultar ou alterar.</p>
    </div>
    <button class="btn-web-primary" type="button" (click)="openCreateDialog()">
      <i class="ri-add-line"></i> Criar Perfil
    </button>
  </header>

  <section class="groups-toolbar" aria-label="Pesquisa e filtros dos grupos">
    <label class="group-search group-search-inline">
      <span class="sr-only">Pesquisar Perfil</span>
      <div>
        <i class="ri-search-line"></i>
        <input pInputText type="search" [value]="searchInput" placeholder="Pesquisar grupo..."
          (input)="onSearchInput($any($event.target).value)" />
        <button *ngIf="searchInput" type="button" aria-label="Limpar pesquisa" (click)="clearGroupFilters()">
          <i class="ri-close-line"></i>
        </button>
      </div>
    </label>
    <button type="button" class="btn-group-filters" (click)="openGroupFilters()">
      <i class="ri-filter-3-line"></i> Filtros 
    </button>
  </section>

  <section class="groups-panel">
    <header class="groups-panel-header">
      <div>
        <span class="panel-eyebrow">Directório de acesso</span>
        <h2>Perfis registados</h2>
        <p>Clique numa linha para configurar as permissões do grupo.</p>
      </div>
      <span class="groups-count"><strong>{{ totalRecords }}</strong> {{ totalRecords === 1 ? 'grupo' : 'Perfis' }}</span>
    </header>

    <div class="data-table-wrapper groups-table-wrapper">
      <table class="data-table groups-table" *ngIf="!loading && !error && grupos.length > 0">
        <thead><tr><th>Grupo</th><th class="col-acoes">Acções</th></tr></thead>
        <tbody>
          @for (g of grupos; track trackByGrupo($index, g)) {
            <tr class="group-row" tabindex="0" (click)="openPermissoesDrawer(g)" (keydown.enter)="openPermissoesDrawer(g)">
              <td>
                <div class="group-identity">
                  <span class="group-avatar">{{ getGroupInitials(g.nome) }}</span>
                  <span><strong>{{ g.nome }}</strong><small><i class="ri-shield-user-line"></i> Grupo de permissões</small></span>
                </div>
              </td>
              <td class="col-acoes">
                <p-menu #rowMenu [model]="menuItemsMap.get(g.id) ?? []" [popup]="true" appendTo="body"></p-menu>
                <button type="button" class="btn-icon-action" aria-label="Acções do grupo"
                  (click)="toggleRowMenu($event, rowMenu); $event.stopPropagation()">
                  <i class="pi pi-ellipsis-v"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-empty-state *ngIf="!loading && !error && grupos.length === 0"
        icon="ri-shield-keyhole-line" title="Nenhum grupo encontrado"
        [message]="searchTerm ? 'Não encontrámos grupos para a pesquisa indicada.' : 'Ainda não existem grupos registados.'"
        [actionLabel]="searchTerm ? 'Limpar pesquisa' : 'Novo grupo'" (action)="handleEmptyAction()">
      </app-empty-state>

      <div *ngIf="!loading && error" class="error-state">
        <i class="ri-error-warning-line"></i>
        <strong>Não foi possível carregar os grupos</strong>
        <p>Verifique a ligação e tente novamente.</p>
        <button class="btn-web-secondary" type="button" (click)="retry()"><i class="ri-refresh-line"></i> Tentar novamente</button>
      </div>

      <div *ngIf="loading" class="skeleton-rows group-skeletons">
        @for (i of [1, 2, 3, 4, 5]; track i) { <p-skeleton height="56px" styleClass="mb-2"></p-skeleton> }
      </div>

      <footer class="groups-pagination" *ngIf="!loading && !error && totalRecords > 0">
        <app-paginator-control [first]="first" [rows]="pageSize" [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[5, 10, 20, 50]" [alwaysShow]="true" [showCurrentPageReport]="true"
          (pageChange)="onPageChange($event)">
        </app-paginator-control>
      </footer>
    </div>
  </section>
  <p-drawer
    [(visible)]="showGroupFiltersDrawer"
    position="right"
    [modal]="true"
    appendTo="body"
    [style]="{ width: 'min(92vw, 390px)' }"
    styleClass="group-filters-drawer"
  >
    <ng-template pTemplate="header">
      <div class="filters-drawer-title">
        <span><i class="ri-equalizer-3-line"></i></span>
        <div><h2 class="fd-title">Filtros de Grupos</h2><p>Refine a listagem pelo nome do grupo.</p></div>
      </div>
    </ng-template>
    <div class="filters-drawer-body">
      <label>
        <span>Nome do Perfil</span>
        <div class="drawer-filter-input">
          <i class="ri-search-line"></i>
          <input type="search" [value]="pendingGroupNameFilter"
            (input)="pendingGroupNameFilter = $any($event.target).value"
            placeholder="Ex.: Administradores" />
        </div>
      </label>
      <div class="filter-api-note">
        <i class="ri-information-line"></i>
        <span>A API disponibiliza o filtro por nome. A quantidade por página é controlada no paginador da listagem.</span>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="filters-drawer-actions">
        <button type="button" class="btn-web-secondary" (click)="$event.stopPropagation(); resetGroupDrawerFilters()">
          <i class="fas fa-undo"></i> Limpar
        </button>
        <button type="button" class="btn-web-primary" (click)="$event.stopPropagation(); applyGroupFilters()">
          <i class="fas fa-check"></i> Aplicar
        </button>
      </div>
    </ng-template>
  </p-drawer>

  <!-- ── DIALOG: Novo grupo ──────────────────────────────── -->
  <p-dialog
    [(visible)]="showCreateDialog"
    header="Perfil"
    [modal]="true"
    [style]="{ width: 'min(90vw, 420px)' }"
    [draggable]="false"
  >
    <div class="dialog-form" [formGroup]="createForm">
      <div class="form-group">
        <label for="nomeGrupo">Nome do Perfil <span class="req">*</span></label>
        <input
          pInputText
          id="nomeGrupo"
          type="text"
          formControlName="nome"
          class="w-full"
          [class.ng-invalid]="isCreateFieldInvalid()"
          [class.ng-dirty]="isCreateFieldInvalid()"
          placeholder="Ex.: SUPERVISORES_LUANDA"
        />
        <small class="field-error" *ngIf="isCreateFieldInvalid()">
          O nome do Perfil é obrigatório e deve ter pelo menos 3 caracteres.
        </small>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <button type="button" class="btn-web-secondary" (click)="showCreateDialog = false">
        Cancelar
      </button>
      <button
        type="button"
        class="btn-web-primary"
        [disabled]="creating"
        (click)="submitCreate()"
      >
        <i [class]="creating ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
        Guardar
      </button>
    </ng-template>
  </p-dialog>

  <p-dialog
    [(visible)]="showEditDialog"
    header="Editar perfil"
    [modal]="true"
    [style]="{ width: 'min(90vw, 420px)' }"
    [draggable]="false"
    [closable]="!savingEdit"
    [closeOnEscape]="!savingEdit"
  >
    <div class="dialog-form" [formGroup]="createForm">
      <div class="form-group">
        <label for="nomeGrupoEditar">Nome do Perfil <span class="req">*</span></label>
        <input
          pInputText
          id="nomeGrupoEditar"
          type="text"
          formControlName="nome"
          class="w-full"
          [class.ng-invalid]="isCreateFieldInvalid()"
          [class.ng-dirty]="isCreateFieldInvalid()"
          placeholder="Ex.: SUPERVISORES_LUANDA"
        />
        <small class="field-error" *ngIf="isCreateFieldInvalid()">
          O nome do Perfil é obrigatório e deve ter pelo menos 3 caracteres.
        </small>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <button type="button" class="btn-web-secondary" [disabled]="savingEdit" (click)="showEditDialog = false">
        Cancelar
      </button>
      <button type="button" class="btn-web-primary" [disabled]="savingEdit" (click)="submitEdit()">
        <i [class]="savingEdit ? 'fas fa-spinner fa-spin' : 'fas fa-save'"></i>
        {{ savingEdit ? 'A guardar...' : 'Guardar alterações' }}
      </button>
    </ng-template>
  </p-dialog>

  <!-- ── DRAWER: Gerir permissões ─────────────────────────── -->
  <app-grupo-permissoes-drawer
    [(visible)]="showPermissoesDrawer"
    [grupo]="grupoSelecionado"
  ></app-grupo-permissoes-drawer>

  <!-- ── DIALOG: Gerir utilizadores ────────────────────────── -->
  <p-dialog
    [(visible)]="showUtilizadoresDrawer"
    [header]="'Utilizadores' + (grupoSelecionado ? ' — ' + grupoSelecionado.nome : '')"
    [modal]="true"
    [style]="{ width: 'min(94vw, 760px)' }"
    [draggable]="false"
  >
    <div *ngIf="loadingUtilizadores" class="skeleton-rows group-skeletons">
      @for (i of [1, 2, 3, 4]; track i) { <p-skeleton height="48px" styleClass="mb-2"></p-skeleton> }
    </div>
    <div *ngIf="!loadingUtilizadores && errorUtilizadores" class="error-state">
      <i class="fas fa-triangle-exclamation"></i>
      <p>Não foi possível carregar os utilizadores.</p>
      <button type="button" class="btn-web-secondary" (click)="loadUtilizadores()">
        <i class="ri-refresh-line"></i> Tentar novamente
      </button>
    </div>
    <app-empty-state
      *ngIf="!loadingUtilizadores && !errorUtilizadores && utilizadores.length === 0"
      icon="ri-team-line"
      title="Sem utilizadores"
      message="Não existem utilizadores registados para apresentar."
    ></app-empty-state>
    <div class="group-users-table-wrap" *ngIf="!loadingUtilizadores && !errorUtilizadores && utilizadores.length > 0">
      <table class="data-table group-users-table">
        <thead><tr><th>Utilizador</th><th>Perfil de conta</th><th>Associação</th><th class="group-users-actions-heading">Acções</th></tr></thead>
        <tbody>
          @for (u of utilizadores; track u.id) {
            <tr>
              <td>
                <strong>{{ u.nome }}</strong>
                <small>{{ u.email || u.userName }}</small>
              </td>
              <td>{{ u.tipoPerfil || '—' }}</td>
              <td>{{ isUtilizadorMembro(u) ? 'Membro' : 'Não membro' }}</td>
              <td class="group-users-actions">
                <button *ngIf="!isUtilizadorMembro(u)" type="button" class="btn-web-secondary" [disabled]="utilizadorEmProcessamento !== null || !u.id"
                  (click)="alterarMembro(u, 'adicionar')">
                  <i [class]="utilizadorEmProcessamento === u.id ? 'fas fa-spinner fa-spin' : 'ri-user-add-line'"></i>
                  Adicionar
                </button>
                <button *ngIf="isUtilizadorMembro(u)" type="button" class="btn-web-danger" [disabled]="utilizadorEmProcessamento !== null || !u.id"
                  (click)="confirmarRemoverUtilizador(u)">
                  <i class="ri-user-unfollow-line"></i> Remover
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </p-dialog>
</div>
